import { useContext } from "react"
import { useIntl } from "react-intl"
import { Modal } from "src/context/modal/Modal"
import { ModalContext } from "src/context/modal/ModalContext"
import type { ModalProps } from "src/context/modal/ModalProvider"
import { AddCustomEquipmentContainer } from "./AddCustomEquipmentContainer"
import { addCustomEquipmentMessages } from "./components/addCustomEquipment.messages"
import type { RichCustomEquipment } from "./useAddCustomEquipment"

export interface AddCustomEquipmentModalProps {
	onAddCustomEquipment: (customEquipment: RichCustomEquipment) => Promise<void> | void
}

export const AddCustomEquipmentModal = ({
	id,
	modalProps: { onAddCustomEquipment },
}: ModalProps<AddCustomEquipmentModalProps>) => {
	const { formatMessage } = useIntl()
	const { hideModal } = useContext(ModalContext)
	return (
		<Modal
			id={id}
			heading={formatMessage(addCustomEquipmentMessages.addCustomEquipment)}
			width="small"
			disableBackdropClick
		>
			<AddCustomEquipmentContainer
				onFormClosed={() => hideModal(id)}
				onAddCustomEquipment={onAddCustomEquipment}
			/>
		</Modal>
	)
}
